import { EventEmitter, Injectable } from "@angular/core";
import { CodeStatusSummary, DeploymentSummary } from "../models/configuration/selfServe/codeManagementObjects";

@Injectable({
    providedIn: 'root'
})
export class EventService {
    public SSCMListStatusChangedEvent = new EventEmitter();
    public SSCMDeploymentCompletedEvent = new EventEmitter();
    public ConcurrentAuth = new EventEmitter<boolean>();
    public SaveButtonStateEvent = new EventEmitter<boolean>();
    public LetterConfigPropertiesEvent = new EventEmitter<any>();
    public NoteTypeUpdatedEvent = new EventEmitter();
    public LookupUpdatedEvent = new EventEmitter();

    public SSCMListStatusChanged(summary: CodeStatusSummary) {
        this.SSCMListStatusChangedEvent.emit(summary);
    }

    public SSCMDeploymentCompleted(summary: DeploymentSummary) {
        this.SSCMDeploymentCompletedEvent.emit(summary);
    }

    public setConcurrentAuthStatus(status: boolean) {
        this.ConcurrentAuth.emit(status);
    }

    public SaveButtonState(isEnabled: boolean) {
        this.SaveButtonStateEvent.emit(isEnabled);
    }

    public LetterConfigPropertiesLoaded(data: any) {
        this.LetterConfigPropertiesEvent.emit(data);
    }

    public NoteTypeUpdated() {
        this.NoteTypeUpdatedEvent.emit();
    }

    public LookupUpdated() {
        this.LookupUpdatedEvent.emit();
    }
}